module.exports = __webpack_public_path__ + "img/HowItWork_item_05.d5f313c7.png";